/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

/** @module browser/modules/is-safe-header */

/**
 * @description Checks if passed HTTP headers are accessible in the specified request.
 * @param {Object<string,*>} req - Request object.
 * @param {string|Array<string>} headers - Headers names to be checked.
 * @returns {boolean} Check Result.
 */
function isSafeHeader(req, headers) {
  var _context,
      _this = this,
      _context2;

  var accessCtrl = _mapInstanceProperty(_context = (req.getResponseHeader('Access-Control-Expose-Headers') || '').split(',')).call(_context, _bindInstanceProperty(_context2 = function _context2(item) {
    _newArrowCheck(this, _this);

    return _trimInstanceProperty(item).call(item);
  }).call(_context2, this));

  headers = _Array$isArray(headers) ? headers : [headers];

  if (accessCtrl.length && headers.length) {
    var _context3;

    return _everyInstanceProperty(headers).call(headers, _bindInstanceProperty(_context3 = function _context3(header) {
      var _this2 = this,
          _context4;

      _newArrowCheck(this, _this);

      return _someInstanceProperty(accessCtrl).call(accessCtrl, _bindInstanceProperty(_context4 = function _context4(key) {
        _newArrowCheck(this, _this2);

        return header === key || key === '*';
      }).call(_context4, this));
    }).call(_context3, this));
  } else {
    return false;
  }
}

export { isSafeHeader };